// Small helpers shared by the Admin tabs

// Turn a Supabase/RPC error into a message an admin can act on
export const adminErrorMessage = (error) => {
  if (!error) return '';
  const msg = error.message || String(error);
  if (error.code === '42883' || error.code === 'PGRST202' || /function .* does not exist|Could not find the function/i.test(msg)) {
    return 'The admin database setup is missing. Run database/2026-11-03_admin.sql in the Supabase SQL Editor.';
  }
  if (error.code === '42P01' || /relation .* does not exist/i.test(msg)) {
    return 'An admin table is missing. Run database/2026-11-03_admin.sql in the Supabase SQL Editor.';
  }
  if (error.code === '42501' || /not authorised/i.test(msg)) return "You're not an admin (or your admin role was removed).";
  return msg;
};

export const formatDateTime = (value) => {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatDay = (value) => {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

// "3 days ago", "Today", "Never"
export const timeAgo = (value) => {
  if (!value) return 'Never';
  const days = Math.floor((Date.now() - new Date(value).getTime()) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30.44);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.floor(days / 365);
  return `${years} year${years === 1 ? '' : 's'} ago`;
};

export const daysSince = (value) => (value ? (Date.now() - new Date(value).getTime()) / 86400000 : Infinity);

// Which module each data table belongs to (for record counts)
export const TABLE_MODULE = {
  transactions: 'transactions', categories: 'transactions',
  wallets: 'wallets',
  loans: 'loans', loan_payments: 'loans',
  insurance_policies: 'insurance', insurance_premiums: 'insurance',
  vehicles: 'utilities', fuel_entries: 'utilities', fastags: 'utilities', fastag_entries: 'utilities',
};
export const moduleOfTable = (table) => TABLE_MODULE[table] || 'investments';

export const ACTION_LABELS = {
  'user.make_admin': 'Made admin',
  'user.remove_admin': 'Removed admin',
  'user.disable': 'Disabled account',
  'user.enable': 'Enabled account',
  'user.password_reset': 'Sent password reset',
  'module.enable': 'Switched module on',
  'module.disable': 'Switched module off',
};
